import { configureStore } from "@reduxjs/toolkit";
import firebaseSlice from "./slices/firebaseSlice";
import tableSlice from "./slices/tableSlice";
export const store = configureStore({
  reducer: {
    firebase: firebaseSlice,
    table: tableSlice,
  },
});
